import React from 'react';
import { logger } from '../../utils/logger';
import Header from '../Header';

interface AppLayoutProps {
  variant?:
  'dashboard'
  | 'capture-snapshot'
  | 'migration-setup'
  | 'approve-transformations'
  | 'approve-export'
  | 'migration-logs'
  | 'snapshot-comparison'
  | 'rollback-preview'
  | 'rollback-initiation';
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ variant = 'dashboard', children }) => {
  React.useEffect(() => {
    logger.debug('AppLayout mounted');
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900" style={{ fontFamily: 'system-ui, sans-serif' }}>
      <Header variant={variant} />
      <div className={`${variant === 'snapshot-comparison' || variant === 'rollback-initiation' ? 'max-w-none px-0' : 'max-w-screen-2xl mx-auto px-6'} py-6`}>
        <main>{children}</main>
      </div>
    </div>
  );
};
